<div class="modal-content">
  <div class="modal-header">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick()" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <h4 jhiTranslate="baryApp.how-to.upload-special-destination.title"></h4>
  </div>
  <div class="mt-3 alert alert-info">
    <p jhiTranslate="baryApp.how-to.upload-special-destination.intro"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-special-destination.file"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-special-destination.format"></p>
    <ul>
      <li jhiTranslate="baryApp.how-to.upload-special-destination.column1"></li>
      <li jhiTranslate="baryApp.how-to.upload-special-destination.column2"></li>
      <li jhiTranslate="baryApp.how-to.upload-special-destination.column3"></li>
      <li jhiTranslate="baryApp.how-to.upload-special-destination.column4"></li>
    </ul>
    <div class="h5">
      <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="info-text pr-2" aria-hidden="true"></jhi-bary-icon>
      <span jhiTranslate="baryApp.how-to.upload-special-destination.sample"></span>
    </div>
    <table mdbTable [hover]="false" [small]="true" class="table-responsive bg-white">
      <tr class="bg-main">
        <th jhiTranslate="baryApp.how-to.upload-special-destination.tab.country"></th>
        <th jhiTranslate="baryApp.how-to.upload-special-destination.tab.inseeCode"></th>
        <th jhiTranslate="baryApp.how-to.upload-special-destination.tab.zipCode"></th>
        <th jhiTranslate="baryApp.how-to.upload-special-destination.tab.city"></th>
      </tr>
      <tr>
        <td>FR</td>
        <td>73201</td>
        <td>73350</td>
        <td>PLANAY</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>73161</td>
        <td>73350</td>
        <td>MONTAGNY</td>
      </tr>
    </table>
    <br />
    <br />
    <div class="h5">
      <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="info-text pr-2" aria-hidden="true"></jhi-bary-icon>
      <span jhiTranslate="baryApp.how-to.upload-special-destination.sampleRules"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-special-destination.sampleRules1"></p>
  </div>
</div>
